<template>
   <!-- 系统设置-->
   <div class="all">
    <!--头部-->
    <div class="qyxxhead">
        <div class="qyxxheadleft">
            <img src="" alt="">
        <div class="qyxxheadtext"> {{info_sys.name}}</div>
        </div></div>
        <!--内容-->
        <!--视频播放设置-->
        <div class="Pbsettings">
            <div class="nametext">视频播放设置:</div>
            <div class="nametext" style="padding: 0 2rem;">进度条控制:</div>
            <div class="">
              <el-switch
                v-model="info_sys.video_percentage"
                @change="save_system('video_percentage')"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
            <div class="nametext" style="padding: 0 2rem;">倍数控制:</div>
            <div class="">
              <el-switch
                v-model="info_sys.video_multiple"
                @change="save_system('video_multiple')"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
        </div>
        <!--考核次数设置-->
        <div class="Pbsettings">
            <div class="nametext">考核次数设置:</div>
            <el-select v-model="info_sys.exam_num" placeholder="请选择" style="padding: 0 2rem;" @change="save_system('exam_num')">
                <el-option
                  v-for="item in exam_num"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        </div>
        <!--密码策略（强制性）-->
        <div class="Pbsettings">
            <div class="nametext">密码策略（强制性）:</div>
            <el-select v-model="info_sys.pwd_time" placeholder="请选择" style="padding: 0 2rem;" @change="save_system('pwd_time')">
                <el-option
                  v-for="item in pwd_time"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        </div>
   </div>
</template>
<script>
  export default {
    data(){
        return{
          info_sys:{},
          exam_num: [{
            value: '1',
            label: '1'
          }, {
            value: '2',
            label: '2'
          }, {
            value: '3',
            label: '3'
          }, {
            value: '4',
            label: '4'
          }, {
            value: '5',
            label: '5'
          }],
          pwd_time:[{
            value: '0',
            label: '关闭'
          }, {
            value: '3',
            label: '每三个月修改一次'
          }, {
            value: '6',
            label: '每六个月修改一次'
          }, {
            value: '12',
            label: '每一年修改一次'
          }],
        }
    },
    mounted() {
      this.get_system()
    },
    methods:{
      get_system(){
        let _this=this
        _this.axios.get('/v2/c_company/get_system').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info_sys=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      save_system(val){
        let _this=this
        var data={
          'type':val,
          'value':_this.info_sys[val]
        }
        _this.axios.post('/v2/c_company/save_system',{data:data}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
            }else{
              _this.$message.error(res.data.msg)
              _this.info_sys[val]=res.data.data.value
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      }

    }
  }
</script>

<style scoped>
.all{
    border: 1px solid rgb(199, 192, 192);
    margin-top: 30px;
    margin-left: 30px;
      width: 100%;
      height: 100%;

}
.qyxxhead{
    width: 100%;
    height: 60px;
    margin-top: 10px;

}
.qyxxheadtext{
    margin-left: 10px;
}

.qyxxheadleft{
  float: left;
  display: flex;
  align-items: center;
  height: 100%;

}
.nametext{
   color:#696969;
}
.Pbsettings{
    border-top: 1px solid rgb(199, 192, 192);
    height: 60px;
    display: flex;
    align-items: center;
   padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/company/System/system.vue